import * as React from 'react';

import styles from './index.module.scss';

export default class Layout extends React.Component {
  public render() {
    return <main className={styles['layout']}>{this.props.children}</main>;
  }
}
